var _templateObject = _taggedTemplateLiteralLoose(['\n  border-top: 1px solid #ccc;\n  margin: 2rem 0 1rem 0;\n  padding-top: 1rem;\n  text-align: center;\n'], ['\n  border-top: 1px solid #ccc;\n  margin: 2rem 0 1rem 0;\n  padding-top: 1rem;\n  text-align: center;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';

export var AlternateCTA = styled.div(_templateObject);


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/auth/StyledComponents.js
// module id = 232
// module chunks = 4